var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReleaseNotesSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H2C0.875 0.5 0 1.40625 0 2.5V12.5C0 13.625 0.875 14.5 2 14.5H9.65625C10.1875 14.5 10.6875 14.3125 11.0625 13.9375L13.4062 11.5938C13.7812 11.2188 14 10.7188 14 10.1875V2.5C14 1.40625 13.0938 0.5 12 0.5ZM12.5 9.5H10C9.46875 9.5 9 9.96875 9 10.5V13H2C1.71875 13 1.5 12.7812 1.5 12.5V2.5C1.5 2.25 1.71875 2 2 2H11.9688C12.2188 2 12.4688 2.25 12.4688 2.5V9.5H12.5Z",
    fill: "#1F58C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleaseNotesSmall);
export default __webpack_public_path__ + "static/media/release-notes-small.4989fa5628d90d7d291e47e1e26d30a2.svg";
export { ForwardRef as ReactComponent };